















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { IBarChartData } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { BillingModule } from '@/store/modules/billing.module'
import Icon from '@/components/Icon.vue'

const moment = require('moment')

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    LoaderWrapper
  }
})
export default class BillingStatistics extends Vue {
  billingInstanceModule: BillingModule = getModule(BillingModule, this.$store);
  isBillingLoading: boolean = false;
  billingParams = {
    months: 5,
    skip: 0
  };
  billingData: Array<{ data: IBarChartData[], date: Date }>= [];

  get billingStatistics () {
    return this.$store.state.billing.byDateStatistics
  }

  async mounted () {
    this.fetchBillingStatistics()
  }

  billingTitleFormatter (total: number) {
    return total
  }

  slideBillingTo (skip: number) {
    this.billingParams.skip += skip
    this.fetchBillingStatistics()
  }

  isBillingPrevAvailable () {
    return this.billingData.length === 5
  }

  isBillingNextAvailable () {
    return this.billingParams.skip !== 0
  }

  async fetchBillingStatistics () {
    this.isBillingLoading = true
    await this.billingInstanceModule.fetchByDateStatistics(this.billingParams)
    this.initBillingStatistics()
    this.isBillingLoading = false
  }
  initBillingStatistics () {
    const maxTotal = Math.max(...this.billingStatistics.map((item: any) => item.gross - item.cost + item.cost))
    this.billingData = this.billingStatistics.map((item: any) => {
      const date = item.date
      return {
        total: maxTotal,
        data: [{
          items: [{
            value: item.gross - item.cost,
            color: '#F2EFF8',
            label: 'Profit'
          },
          {
            value: item.cost,
            color: '#9966FF',
            label: 'Cost'
          }]
        }],
        date
      }
    })
  }
}
